import { render, staticRenderFns } from "./atlas_result.vue?vue&type=template&id=dd07197c&scoped=true"
import script from "./atlas_result.vue?vue&type=script&lang=js"
export * from "./atlas_result.vue?vue&type=script&lang=js"
import style0 from "./atlas_result.vue?vue&type=style&index=0&id=dd07197c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd07197c",
  null
  
)

export default component.exports